module.exports = __webpack_public_path__ + "media/organizations/htwBerlin-8596a31b.webp";